function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcfcfc",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M352 233.88h-22.154c0 40.784-33.063 73.846-73.846 73.846-40.785 0-73.846-33.062-73.846-73.846H160c0 43.931 29.509 80.969 69.787 92.377-4.415 8.389-3.743 18.951 2.564 26.822l24.141-19.346 24.141 19.346c6.371-7.95 6.998-18.646 2.434-27.075C322.905 314.318 352 277.5 352 233.88z",
  fill: "#6da544"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M196.923 226.497s0 36.923 36.923 36.923l7.385 7.385H256s7.385-22.154 22.154-22.154c0 0 0-14.769 14.769-14.769h22.154s-7.385-29.538 29.538-51.692l-14.769-7.385s-51.692 36.923-88.615 29.538v14.769h-14.769l-7.385-7.385-22.154 14.77z",
  fill: "#ffda44"
});

const SvgCyprus = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCyprus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cyprus.b3ddf15d.svg";
export { ForwardRef as ReactComponent };